// extracted by mini-css-extract-plugin
module.exports = {"label":"UnbanModal_label__2ePur","buttons":"UnbanModal_buttons__12YcV"};